<template>
  <div class="detail-item">
    <span
      class="detail-item__icon"
    >
      <icon-warning v-if="hasAlert"/>
    </span>
    <a
      :href="shownHref"
      :class="{
        'item-title--active': isActive,
      }"
      :target="anchorTarget"
      class="detail-item__link item-title">
      {{ title }}
      <icon-new-window
        v-if="isTargetBlank"
        class="item-title__icon"/>
    </a>
  </div>
</template>

<script>
import { detailItemProps } from '@/mikan/_shared/types/vueTypes/restaurantNavigation';
import IconWarning from '@/mikan/_shared/components/atoms/icons/IconWarning.vue';
import IconNewWindow from '@/mikan/_shared/components/atoms/icons/IconNewWindow.vue';

export default {
  components: {
    IconWarning,
    IconNewWindow,
  },
  props: {
    ...detailItemProps,
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shownHref() {
      return this.isActive ? '' : this.path;
    },
    anchorTarget() {
      return this.isTargetBlank ? '_blank' : '_self';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

$icon-size: 1.33em;

.detail-item {
  display: flex;
  align-items: center;

  &__icon {
    display: flex;
    width: $icon-size;
    height: $icon-size;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    padding: 1em;
  }

  &__link {
    flex: 1 0 auto;
    border-top: 1px solid $color-navy-20;
    font-size: 1em;
  }
}

.item-title {
  display: block;
  align-items: center;
  padding: 1em;
  color: $color-text-link;
  font-weight: bold;
  transition: color $transition-base;

  @include for-tb-pc {
    font-size: $size-s;
  }

  @include for-sp {
    font-size: 14px;
  }

  @include is-pointer-device {
    &:hover {
      color: $color-text-link-hover;
    }
  }

  &__icon {
    font-size: 10px;
  }

  &--active {
    background: $gradient-orange;
    color: $color-white;
    pointer-events: none;
  }

  &--nested {
    background: $color-navy-03;
    font-weight: normal;
  }
}
</style>
